<!-- Lesson started -->
<div id="videoDiv" style="height:100vh;">
    
</div>

<div style="display:none;" *ngIf="lessonStatus == 'STARTED'">
    <div simpleCountdown class="countdown" [dateTo]="lessonEndTime/1000" (finish)="timerFinished()"
    ></div>
</div>

<audio id="metroNomeAudioElem">
    <source src="assets/audio/metronome.mp3" type="audio/ogg">
</audio>

<div class="controllers" *ngIf="lessonStatus == 'STARTED'">
    <button (click)="endCall();" class="controllerBtn">End</button>
    <button (click)="executeCommand('toggleShareScreen')" class="controllerBtn">Screen Share</button>
    <button (click)="toggleCamera();" class="controllerBtn">Change Camera</button>
    <button (click)="executeCommand('toggleAudio')" class="controllerBtn" *ngIf="!isAudioMuted">Mute Audio</button>
    <button (click)="executeCommand('toggleAudio')" class="controllerBtn" *ngIf="isAudioMuted">UnMute Audio</button>
    <button (click)="openWhieBoard()" class="controllerBtn">White Board</button>
    <div class="dropdown" style="display:inline;">
        <button class="controllerBtn" (click)="toggleDropdown()"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            Functions <i class="fas fa-caret-down ml-2"></i>
        </button>

        <ul class="dropdown-list" [class.show]="isMenuOpen">
            <li><a class="dropdown-item" (click)="toggleMetronome()">Metronome</a></li>
            <li><a class="dropdown-item" (click)="toggleCalculator()">Calculator</a></li>
            <li><a class="dropdown-item" (click)="togglePeriodicTable()">PeriodicTable</a></li>
            <li><a class="dropdown-item" (click)="toggleDictionary()">Dictionary</a></li>
        </ul>
    </div>
    <button *ngIf="hideVirtualBackgroundBtn" (click)="toggleVirtualBackground()" class="controllerBtn">Virtual Background</button>
    <button (click)="executeCommand('toggleChat')" class="controllerBtn">Chat</button>
    <button (click)="toggleTileViewBtn()" class="controllerBtn">Tile View</button>

</div>

<!-- Lesson started -->

<!-- Yet To Start -->

<div *ngIf="lessonStatus == 'YET_TO_START'" class="status-text-style">
    <div class="centerd">
        <h1 style="color:#47defd">Session Starts in </h1>
        <div simpleCountdown class="countdown" [dateTo]="lessonStartTime/1000" (finish)="timerFinished()"
        [endMessage]="'Session loading....'"
        [styles]="'font-size: 40px;
        color: #fc7f38;
        background-color: #272727;
        padding: 10px 4px;
        font-weight: bold;'"
        ></div>
    </div>
</div>

<!-- Yet To Start -->

<!-- Expired -->

<div *ngIf="lessonStatus == 'EXPIRED'" class="status-text-style">
    <div class="centerd">
        <h1 style="color:#47defd;">Session Expired</h1>
    </div>
    
</div>

<!-- Invalid Lesson -->

<div *ngIf="lessonStatus == 'INVALID'" class="status-text-style">
    <div class="centerd">
        <h1 style="color:#47defd;">Invalid Lesson</h1>
    </div>
    
</div>

<div *ngIf="isDictionary" class="dictionary" cdkDrag>
    <span style="position: absolute;right: 20px; cursor: pointer;z-index: 11; top:10px;"
        (click)="toggleDictionary();">x</span>
    <span style="position: absolute;right: 30px; cursor: pointer;z-index: 11; top:11px;" id="dictionary" cdkDragHandle>
        <mat-icon aria-hidden="false" aria-label="Example home icon" style="font-size: 15px;">open_with</mat-icon></span>
    <!-- <iframe src="https://dictionary-ui.meteortutors.com/" title="Dictionary"
        style="width:100%; height:100%;border-radius: 15px; border-width: 0;"></iframe> -->
        <div style="width:100%; height:100%;border-radius: 15px; border-width: 0;">
            <app-lesson-dictionary></app-lesson-dictionary>
        </div>
</div>

<div *ngIf="showMetronome" class="meteornomebox-ctrl">
    <span style="position: absolute; right: 20px; cursor: pointer; z-index: 11;" (click)="toggleMetronome()">x</span>
    <div class="col-md-12">
        <div><span>{{selectedBPM}}</span></div>

        <div style="float:left;">
        <label for="bpmRange">BPM</label>
        </div>
        <div>
            <input type="range" class="form-range" id="bpmRange" [value]="selectedBPM" min="40" max="300" (input)="updateBpmDisplay($event)" />
        </div>
        <div style="float:left; width:35px;">
            <label for="volumeRange"><i class="fas fa-volume-up"></i></label>
        </div>

        <div>
            <input type="range" class="form-range" id="volumeRange" [value]="volume" min="0" max="100" (input)="changeVolume($event)" />
        </div>
        <div class="col-md-12">
            <div class="p-2">
                <i class="fas fa-play"  *ngIf="!isPlaying" role="button" (click)="playMetronome()"></i>
                <i class="fas fa-pause" *ngIf="isPlaying" role="button" (click)="pauseMetronome()"></i>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showCalculator" class="calculator-box" cdkDrag>
    <span style="position: absolute;right: 20px; cursor: pointer;z-index: 11; top:10px;" (click)="toggleCalculator()">x</span>
	<span style="position: absolute;right: 40px; cursor: pointer;z-index: 11; top:11px;" id="calculatorheader" cdkDragHandle><i class="fas fa-arrows-alt"></i></span>
    <iframe src="https://calculator.meteortutors.com" title="Calculator" style="width:100%; height:100%;border-radius: 15px; border-width: 0;" ></iframe>
</div>

<div *ngIf="showPeriodicTable" id="periodicTable" cdkDrag>
	<span style="position: absolute;right: 20px; cursor: pointer;z-index: 11; top:10px;" (click)="togglePeriodicTable()">x</span>
	<span style="position: absolute;right: 40px; cursor: pointer;z-index: 11; top:11px;" id="periodTableHeader" cdkDragHandle><i class="fas fa-arrows-alt"></i></span>
	<iframe src="https://periodic.meteortutors.com" title="Calculator" style="width:100%; height:100%;border-radius: 15px; border-width: 0;"></iframe>
</div>